import { render, staticRenderFns } from "./PreviewUser.vue?vue&type=template&id=54f43977&scoped=true&"
import script from "./PreviewUser.vue?vue&type=script&lang=js&"
export * from "./PreviewUser.vue?vue&type=script&lang=js&"
import style0 from "./PreviewUser.vue?vue&type=style&index=0&id=54f43977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f43977",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VIcon,VImg,VLayout})
